import * as yup from 'yup';
import i18n from 'i18next';

const schema = yup
  .object({
    userName: yup.string().required(() => i18n.t('auth.required')),
    password: yup.string().required(() => i18n.t('auth.required')),
  })
  .required();

export default schema;
